import { render, staticRenderFns } from "./Produk.vue?vue&type=template&id=1547795c&"
import script from "./Produk.vue?vue&type=script&lang=js&"
export * from "./Produk.vue?vue&type=script&lang=js&"
import style0 from "./Produk.vue?vue&type=style&index=0&id=1547795c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports